import {mapGetters} from 'vuex'

export const hideRoles = {
  computed: {
    ...mapGetters({
      adminRole: 'auth/adminRole'
    })
  },
  watch: {
    adminRole(val) {
      if (!val) {
        this.$router.push('/403')
      }
    }
  },
}
